import React, { useEffect, useState } from 'react';
import { Form, Input, Select, Row, Col } from 'antd';
import BirthdateInput from '../shared/BirthdateInput';
import DateHelper from '../helpers/DateHelper';
import ValidatorHelper from '../helpers/ValidatorHelper';
import StringHelper from '../helpers/StringHelper';
import UserServices from '../../services/UserServices';
import { usePersistedStore } from '../../store/persisted-store';
import { useGeneralStore } from '../../store/slices/createGeneralSlice';
import OnlyNumber from '../shared/OnlyNumbers';

export default function UserForm({ user, onSubmit, formType, pageNumber, pageSize }) {

    const [form] = Form.useForm();
    const { business, users, FILTERED_ITEM, FILTER_USERS, GET_ALL_USERS, SET_TOTAL_USERS, USER_LOADING } = usePersistedStore();
    const general = useGeneralStore();
    const usersData = users.data;
    const provinces = general.provinces.data.Provinces;
    const cities = general.cities.data.Cities;
    const roleList = business.businesses.roles.Roles;
    const currentBusiness = business.currentBusiness;
    const [userLoading, setUserLoading] = useState(false);
    const { token } = currentBusiness;

    function onFinish(values) {
        if (values.ProvinceId && !values.CityId)
            general.NotifError('شهر را انتخاب کنید');
        else {
            if (formType) {
                setUserLoading(true)
                UserServices.updateUser({
                    Password: values.Password,
                    FirstName: values.FirstName ? values.FirstName : null,
                    LastName: values.LastName ? values.LastName : null,
                    FatherName: values.FatherName ? values.FatherName : null,
                    NationalCode: (StringHelper.getEnglishNum(values.NationalCode)),
                    MobileNumber: (StringHelper.getEnglishNum(values.MobileNumber ? values.MobileNumber : null)),
                    Phone: (StringHelper.getEnglishNum(values.Phone ? values.Phone : null)),
                    CityId: values.CityId,
                    RoleIds: values.RoleIds,
                    BirthDate: values.BirthDate && DateHelper.objToDate(values.BirthDate),
                    IBAN: (StringHelper.getEnglishNum(values.IBAN)),
                }, values.UserName, token).then((res) => {
                    if (res.status === 200) {
                        onSubmit();
                    }
                    getUsersPerPage();
                    setUserLoading(false)
                }).catch((error) => {
                    setUserLoading(false)
                })
            }
            else {
                setUserLoading(true)
                UserServices.postUser({
                    UserName: values.UserName,
                    Password: values.Password,
                    FirstName: values.FirstName ? values.FirstName : null,
                    LastName: values.LastName ? values.LastName : null,
                    FatherName: values.FatherName ? values.FatherName : null,
                    NationalCode: (StringHelper.getEnglishNum(values.NationalCode)),
                    MobileNumber: values.MobileNumber ? StringHelper.getEnglishNum(values.MobileNumber) : null,
                    Phone: values.Phone ? StringHelper.getEnglishNum(values.Phone) : null,
                    CityId: values.CityId,
                    RoleIds: values.RoleIds,
                    BirthDate: values.BirthDate && DateHelper.objToDate(values.BirthDate),
                    IBAN: StringHelper.getEnglishNum(values.IBAN),
                }, token).then((res) => {
                    if (res.status === 200) {
                        onSubmit();
                    }
                    getUsersPerPage();
                    setUserLoading(false)
                }).catch((error) => {
                    setUserLoading(false)

                })

            }
        }
    };

    function getUsersPerPage() {
        USER_LOADING(true)
        if (token)
            UserServices.getUsersPerPage(token, {
                // sorts: [{
                //     Member: member,
                //     SortDirection: sortDirection
                // }],
                page: pageNumber,
                pageSize: pageSize,
                filters: null,
                groups: null,
                aggregates: null

            }).then((res) => {

                GET_ALL_USERS(res.data.Data)
                SET_TOTAL_USERS(res.data.Total)
                USER_LOADING(false)
            }).catch((error) => {
                USER_LOADING(false)

            })
    }
    // function getAllUsers() {

    //     UserServices.getAllUsers(token).then((res) => {
    //         console.log('res', res)
    //         dispatch(GET_ALL_USERS(res.data))
    //         filterUsers(filteredItem)
    //         dispatch(USER_LOADING(false))
    //     }).catch((error) => {
    //         dispatch(USER_LOADING(false))

    //     })
    // }

    function filterUsers(value) {
        const payload = usersData.filter(item => {
            return (item.DisplayName && item.DisplayName.includes(value)) ||
                (item.Username && item.Username.includes(value));
        });
        FILTERED_ITEM(value)
        FILTER_USERS(payload)
    }
    useEffect(() => {
        general.getProvinces();
        if (user && user.ProvinceId)
            general.getCities(user.ProvinceId)
        if (user)
            form.setFieldsValue({
                ...user,
                BirthDate: user.BirthDate && DateHelper.dateToObj(user.BirthDate)
            });
        else
            form.resetFields();
    }, [form, user])

    const formLayout = {
        labelCol: {
            lg: 7,
            xs: 24
        },
        wrapperCol: {
            lg: 15,
            xs: 24
        }
    }
    const itemLayout = {
        lg: 12,
        md: 12,
        sm: 24,
        xs: 24
    }

    return (
        <Form
            form={form}
            name="user-form"
            className='business-form'
            {...formLayout}
            onFinish={onFinish}
            autoComplete="off">
            <Row>
                <Col {...itemLayout}>
                    <Form.Item
                        rules={ValidatorHelper.userName()}
                        name="UserName"
                        label="نام کاربری">
                        <Input disabled={user} />
                    </Form.Item>
                </Col>
                <Col {...itemLayout}>
                    <Form.Item
                        rules={formType ? ValidatorHelper.password() : ValidatorHelper.userFormPassword()}
                        name="Password"
                        label="کلمه عبور">
                        <Input type="password" autoComplete="false" />
                    </Form.Item>
                </Col>
                <Col {...itemLayout}>
                    <Form.Item
                        rules={ValidatorHelper.firstname()}
                        name="FirstName"
                        label="نام">
                        <Input />
                    </Form.Item>
                </Col>
                <Col {...itemLayout}>
                    <Form.Item
                        rules={ValidatorHelper.lastname()}
                        name="LastName"
                        label="نام خانوادگی">
                        <Input />
                    </Form.Item>
                </Col>
                <Col {...itemLayout}>
                    <Form.Item
                        rules={ValidatorHelper._farsi("نام پدر")}
                        name="FatherName"
                        label="نام پدر">
                        <Input />
                    </Form.Item>
                </Col>
                <Col {...itemLayout}>
                    <Form.Item
                        rules={ValidatorHelper.nationalCode()}
                        onKeyPress={e => OnlyNumber(e)}
                        name="NationalCode"
                        label="کد ملی">
                        <Input maxLength={10} />
                    </Form.Item>
                </Col>
                <Col {...itemLayout}>
                    <Form.Item
                        rules={ValidatorHelper.mobile()}
                        name="MobileNumber"
                        onKeyPress={e => OnlyNumber(e)}
                        label="موبایل">
                        <Input maxLength={11} />
                    </Form.Item>
                </Col>
                <Col {...itemLayout}>
                    <Form.Item
                        rules={ValidatorHelper.phone()}
                        onKeyPress={e => OnlyNumber(e)}
                        name="Phone"
                        label="تلفن">
                        <Input maxLength={11} />
                    </Form.Item>
                </Col>
                <Col {...itemLayout}>
                    <Form.Item
                        name="ProvinceId"
                        label="استان">
                        <Select onChange={provinceId => { general.getCities(provinceId) }}>
                            {provinces && provinces.map(province => <Select.Option key={province.Id} value={province.Id}>{province.Title}</Select.Option>)}
                        </Select>
                    </Form.Item>
                </Col>
                <Col {...itemLayout}>
                    <Form.Item
                        name="CityId"
                        label="شهر">
                        <Select disabled={cities === undefined || cities.length === 0 || (user && (user.CityId === undefined))}>
                            {cities && cities.map((city) => <Select.Option key={city.Id} value={city.Id}>{city.Title}</Select.Option>)}
                        </Select>
                    </Form.Item>
                </Col>
                <Col {...itemLayout}>
                    <Form.Item
                        name="BirthDate"
                        label="تاریخ تولد">
                        <BirthdateInput placeholder="تاریخ تولد" />
                    </Form.Item>
                </Col>
                <Col {...itemLayout}>
                    <Form.Item
                        rules={ValidatorHelper.number('شماره شبا')}
                        name="IBAN"
                        label="شماره شبا">
                        <Input maxLength={24} />
                    </Form.Item>
                </Col>
                <Col {...itemLayout}>
                    <Form.Item
                        name="RoleIds"
                        label="دسترسی ها">
                        <Select mode="multiple">
                            {roleList && roleList.map(role => <Select.Option key={role.Id} value={role.Id}>{role.Title}</Select.Option>)}
                        </Select>
                    </Form.Item>
                </Col>
            </Row>
            <button type="primary" className="btn btn-primary waves-effect waves-light" htmltype="submit" style={{ width: "100%" }}>
                <i className={`${userLoading ? "bx bx-loader bx-spin" : "bx bx-check-double"} "font-size-14 align-middle mr-2 ml-3"`}></i>ثبت
            </button>
        </Form>
    )
}
